import React, { useState, useEffect } from 'react';
import { Card, CardBody, Row, Col, Spinner } from "reactstrap";
import ReactApexChart from 'react-apexcharts';
import { fetchBetaSalesRequest } from "../../store/Dashboard/dashboardAction";
import { useSelector, useDispatch } from "react-redux";
import "./dashboard.scss";

const BetaSalesAnalytics = () => {
    const [series, setSeries] = useState([0, 0]);
    const [total, setTotal] = useState(0);
    const [timeRange, setTimeRange] = useState(3);

    const dispatch = useDispatch();
    const { data: betaSales, loading, error } = useSelector(
        (state) => state.betaSales || {}  
    );

    useEffect(() => {
        dispatch(fetchBetaSalesRequest(timeRange));
    }, [dispatch, timeRange]);

    useEffect(() => {
        if (betaSales && betaSales.androidCount !== undefined && betaSales.iOSCount !== undefined) {
            setTotal(betaSales.androidCount + betaSales.iOSCount);
            setSeries([betaSales.androidCount, betaSales.iOSCount]);
        }
    }, [betaSales]);
    
    const options = {
        labels: ["Android Beta", "iOS Beta"],
        plotOptions: {
            pie: {
                donut: {
                    size: '75%',
                },
            },
        },
        dataLabels: {
            enabled: false,
        },
        legend: {
            show: false,
        },
        colors: ['#5664d2', '#1cbb8c'],
    };

    return (
        <React.Fragment>
            <Card>
                <CardBody>
                    {/* Time range selection */}
                    <div className="float-end">
                        <select
                            className="form-select form-select-sm"
                            value={timeRange}
                            onChange={(e) => setTimeRange(parseInt(e.target.value))}
                        >
                            <option value={3}>3 Days</option>
                            <option value={5}>5 Days</option>
                            <option value={7}>7 Days</option>
                        </select>
                    </div>

                    <h4 className="card-title mb-4">Beta Sales Summary</h4>

                    {/* Loading state */}
                    {loading ? (
                        <div className="d-flex justify-content-center">
                            <Spinner color="primary" />
                        </div>
                    ) : error ? (
                        <div className="alert alert-danger">{error}</div>
                    ) : (
                        <div id="donut-chart" className="apex-charts" style={{ position: 'relative' }}>
                            {/* Chart */}
                            <ReactApexChart options={options} series={series} type="donut" height="225" />

                            {/* Overlay for Total */}
                            <div
                                style={{
                                    position: 'absolute',
                                    top: '50%',
                                    left: '50%',
                                    transform: 'translate(-50%, -50%)',
                                    textAlign: 'center',
                                }}
                            >
                                <h6>Total Sales</h6>
                                <p style={{ fontSize: '1.5rem', margin: 0 }}>{total}</p>
                            </div>
                        </div>
                    )}

                    {/* Stats below the chart */}
                    <Row>
                        <Col xs={5}>
                            <div className="text-center mt-4">
                                <p className="mb-2 text-truncate">
                                    <i className="mdi mdi-circle text-success font-size-10 me-1"></i>iOS Beta
                                </p>
                                <h5>{series[1]} Emails</h5>
                            </div>
                        </Col>
                        <Col xs={5}>
                            <div className="text-center mt-4">
                                <p className="mb-2 text-truncate">
                                    <i className="mdi mdi-circle text-primary font-size-10 me-1"></i>Android Beta
                                </p>
                                <h5>{series[0]} Emails</h5>
                            </div>
                        </Col>
                    </Row>
                </CardBody>
            </Card>
        </React.Fragment>
    );
};

export default BetaSalesAnalytics;
